export const environment = {
  production: false,
  mode: 'prod',
  baseUrl: 'https://dashboard-dev.orderna.io',
  apiBaseUrl: 'https://api-dev.orderna.io',
  api: 'https://api-dev.orderna.io/api/v1',
  // baseUrl: 'http://127.0.0.1:4200',
  // apiBaseUrl: 'http://127.0.0.1:3000',
  // api: 'http://127.0.0.1:3000/api/v1',
  service: {
    auth: true,
    users: true,
    customer: true,
    transactions: true,
    stores: true,
    suppliers: true,
    products: true,
    discounts: true,
    userProfiles: true,
    subscriptionPlans: true,
    billingInvoices: true,
    feedbacks: false,
    inventory: true,
    purchases: true,
    revenues: true,
    zReports: true,
    averageTransactionValue: true,
    dayOfWeekSales: true,
    productSales: true,
    timeOfDaySales: true,
    categorySales: true,
    tipsByDays: true,
    discountSummaries: true,
    discountedTransactions: true,
    refundedTransactions: true,
    failedTransactions: true,
    dailySummaries: true,
    allTransactions: true,
    cashRegisters: false,
    cashRegisterSessions: true,
    cashDrawers: true,
    dashboard: true,
    categories: true,
  },
  subscriptionModalEnabled: false,
  allowManualSerialNumber: true,
};
